// extracted by mini-css-extract-plugin
export default {"box":"pPPhPzMb3kNPX9hBXr_a","link":"nt5m8mwHJlRjg0yfuC5k"};